import { format } from 'date-fns';

const WITH_HOURS_FORMAT = 'yyyy-MM-dd HH:mm';
const WITH_HOURS_FORMAT_FOR_BACKEND = "yyyy-MM-dd'T'HH:mm";
const WITHOUT_HOURS_FORMAT = 'yyyy-MM-dd';

export const withHours = (date: string | Date) => format(new Date(date), WITH_HOURS_FORMAT);
export const withHoursForBackend = (date: string | Date) => format(new Date(date), WITH_HOURS_FORMAT_FOR_BACKEND);
export const withoutHours = (date: string | Date) => format(new Date(date), WITHOUT_HOURS_FORMAT);

export type DateRangeInput = {
  from?: Date;
  to?: Date;
};

export type DateRange = {
  from?: string;
  to?: string;
};

export const dateTimeRange = ({ from, to }: DateRangeInput): DateRange => {
  return {
    from: from && `${withHoursForBackend(from)}`,
    to: to && `${withHoursForBackend(to)}`,
  };
};

export const dateRange = ({ from, to }: DateRangeInput): DateRange => {
  return {
    from: from && `${withoutHours(from)}`,
    to: to && `${withoutHours(to)}`,
  };
};
